/* eslint-disable */
import { combineEpics, ofType, StateObservable } from 'redux-observable';
import { of, from } from 'rxjs';
import { mergeMap, catchError } from 'rxjs/operators';

import {
  createOrUpdateConversationFailure,
  createOrUpdateConversationSuccess,
  getConversationsFailure,
  getConversationsSuccess,
  getMessagesFailure,
  getMessagesSuccess,
  getConversationByIdSuccess,
  getConversationByIdSuccess_ADMIN,
  getConversationByIdFailure,
  updateConvoReadStatusSuccess,
  updateConvoReadStatusFailure,
  updateConvoReadStatusSuccess_ADMIN,
  getFileBlobSuccess,
  getFileBlobFailure,
  getConversationsWithInstructorsSuccess,
  getConversationsWithInstructorsFailure,
  fetchtMessagesFailure,
  fetchMessagesSuccess,
} from './action';
import {
  CREATE_OR_UPDATE_CONVERSATION_REQUEST,
  GET_CONVERSATIONS_REQUEST,
  GET_MESSAGES_REQUEST,
  GET_CONVERSATION_BY_ID_REQUEST,
  UPDATE_CONVERSATION_READ_STATUS_REQUEST,
  GET_FILE_TO_BLOB_REQUEST,
  GET_CONVERSATIONS_WITH_INSTRUCTORS_REQUEST,
  PAGINATE_MESSAGES_REQUEST,
} from './actionType';
import { setUser } from '../user/action';

export const createOrUpdateConversationEpic = (
  action$,
  state$,
  {
    conversationInteractor: { addOrUpdateConversation },
    utils: { formatMessage },
  },
) =>
  action$.pipe(
    ofType(CREATE_OR_UPDATE_CONVERSATION_REQUEST),
    mergeMap(({ payload: { params } }) => {
      return from(addOrUpdateConversation(params)).pipe(
        mergeMap(response => {
          const { user, conversation, message } = response;
          const [formattedMessage] = formatMessage([message]);

          let messageArr = [];
          if (
            formattedMessage.content &&
            formattedMessage.attachmentURLs.length > 0
          ) {
            messageArr.push(formattedMessage);
            formattedMessage.attachmentURLs.forEach((data, index) => {
              messageArr.push({
                ...formattedMessage,
                id: formattedMessage.id.concat('_' + index),
                content: '',
                attachmentURLs: [data],
              });
            });
          } else if (
            !formattedMessage.content &&
            formattedMessage.attachmentURLs.length > 0
          ) {
            formattedMessage.attachmentURLs.forEach((data, index) => {
              messageArr.push({
                ...formattedMessage,
                id: formattedMessage.id.concat('_' + index),
                content: '',
                attachmentURLs: [data],
              });
            });
          } else {
            messageArr = formattedMessage;
          }

          return [
            createOrUpdateConversationSuccess({
              conversation,
              message: messageArr,
            }),
            setUser(user),
          ];
        }),
        catchError(error => {
          return of(createOrUpdateConversationFailure(error));
        }),
      );
    }),
  );

export const getConversationsEpic = (
  action$,
  state$,
  {
    conversationInteractor: { getUserConversations },
    utils: { arrayOfObjectsToObject },
  },
) =>
  action$.pipe(
    ofType(GET_CONVERSATIONS_REQUEST),
    mergeMap(({ payload: { params } }) => {
      return from(getUserConversations(params)).pipe(
        mergeMap(response => {
          const conversations = arrayOfObjectsToObject(response, 'id');
          let formatedConversations = {};

          Object.entries(conversations).forEach(([key, value]) => {
            const content = value.previewMessageData.content;
            let formatedConvo = {
              ...value,
              previewMessageData: {
                ...value.previewMessageData,
                content: content !== '' ? content : 'ファイルを受信しました。',
              },
            };
            formatedConversations = {
              ...formatedConversations,
              [key]: formatedConvo,
            };
          });
          return [getConversationsSuccess(formatedConversations)];
        }),
        catchError(error => {
          return of(getConversationsFailure(error));
        }),
      );
    }),
  );

export const getMessagesEpic = (
  action$,
  state$,
  { conversationInteractor: { getUserMessages }, utils: { formatMessage } },
) =>
  action$.pipe(
    ofType(GET_MESSAGES_REQUEST),
    mergeMap(({ payload: { conversationId } }) => {
      return from(getUserMessages(conversationId)).pipe(
        mergeMap(response => {
          const messages = response[conversationId];
          const formattedMessages = formatMessage(messages);
          let messageArr = [];
          if (
            formattedMessages[0].content &&
            formattedMessages[0].attachmentURLs.length > 0
          ) {
            messageArr.push(formattedMessages[0]);
            formattedMessages[0].attachmentURLs.forEach((data, index) => {
              messageArr.push({
                ...formattedMessages[0],
                id: formattedMessages[0].id.concat('_' + index),
                content: '',
                attachmentURLs: [data],
              });
            });
          } else if (
            !formattedMessages[0].content &&
            formattedMessages[0].attachmentURLs.length > 0
          ) {
            formattedMessages[0].attachmentURLs.map((data, index) =>
              messageArr.push({
                ...formattedMessages[0],
                id: formattedMessages[0].id.concat('_' + index),
                content: '',
                attachmentURLs: [data],
              }),
            );
          } else {
            messageArr = formattedMessages;
          }

          return [
            getMessagesSuccess({
              id: conversationId,
              messages: messageArr,
            }),
          ];
        }),
        catchError(error => {
          return of(getMessagesFailure(error));
        }),
      );
    }),
  );

export const fetchMessagesEpic = (
  action$,
  state$,
  {
    conversationInteractor: { paginateUserMessages },
    utils: { formatMessage },
  },
) =>
  action$.pipe(
    ofType(PAGINATE_MESSAGES_REQUEST),
    mergeMap(({ payload: { conversationId, query } }) => {
      return from(paginateUserMessages(conversationId, query)).pipe(
        mergeMap(response => {
          const messages = response[conversationId];
          const formattedMessages = formatMessage(messages.data);

          let messageArr = [];

          formattedMessages.map(async val => {
            if (val.attachmentURLs && val.attachmentURLs.length) {
              for (let i = 0; i < val.attachmentURLs.length; i++) {
                messageArr.push({
                  ...val,
                  id: val.id.concat('_' + i),
                  content: '',
                  attachmentURLs: [val.attachmentURLs[i]],
                });
              }
            }
            if (val.content !== '')
              messageArr.push({
                ...val,
                attachmentURLs: undefined,
              });
          });

          return [
            fetchMessagesSuccess({
              id: conversationId,
              messages: messageArr,
              hasNextPage: messages.hasNextPage,
            }),
          ];
        }),
        catchError(error => {
          return of(fetchtMessagesFailure(error));
        }),
      );
    }),
  );

export const getConversationByIdEpic = (
  action$,
  state$,
  { conversationInteractor: { getConversationById } },
) =>
  action$.pipe(
    ofType(GET_CONVERSATION_BY_ID_REQUEST),
    mergeMap(({ payload: { id } }) => {
      return from(getConversationById(id)).pipe(
        mergeMap(response => {
          const content = response.previewMessageData.content;
          let formatedResponse = {
            ...response,
            previewMessageData: {
              ...response.previewMessageData,
              content: content !== '' ? content : 'ファイルを受信しました。',
            },
          };

          if (response.id.includes('admin')) {
            return [getConversationByIdSuccess_ADMIN(formatedResponse)];
          }
          return [getConversationByIdSuccess(formatedResponse)];
        }),
        catchError(error => {
          return of(getConversationByIdFailure(error));
        }),
      );
    }),
  );

export const updateConvoReadStatusEpic = (
  action$,
  state$,
  { conversationInteractor: { updateMessageReadStatus } },
) =>
  action$.pipe(
    ofType(UPDATE_CONVERSATION_READ_STATUS_REQUEST),
    mergeMap(({ payload: { conversationId, userId } }) => {
      return from(updateMessageReadStatus(conversationId, userId)).pipe(
        mergeMap(response => {
          if (response.id.includes('admin')) {
            return [updateConvoReadStatusSuccess_ADMIN(response)];
          }
          return [updateConvoReadStatusSuccess(response)];
        }),
        catchError(error => {
          return of(updateConvoReadStatusFailure(error));
        }),
      );
    }),
  );

export const getFileBlobEpic = (
  action$,
  state$,
  { conversationInteractor: { getFileToBlob } },
) =>
  action$.pipe(
    ofType(GET_FILE_TO_BLOB_REQUEST),
    mergeMap(({ payload: { params } }) => {
      return from(getFileToBlob(params)).pipe(
        mergeMap(response => {
          return [getFileBlobSuccess(response)];
        }),
        catchError(error => {
          return of(getFileBlobFailure(error));
        }),
      );
    }),
  );

export const getConversationsWithInstructorsEpic = (
  action$,
  state$,
  {
    conversationInteractor: { getConversationsWithInstructors },
    utils: { arrayOfObjectsToObject },
  },
) =>
  action$.pipe(
    ofType(GET_CONVERSATIONS_WITH_INSTRUCTORS_REQUEST),
    mergeMap(({ payload: { userId, instructorsIds } }) => {
      return from(getConversationsWithInstructors(userId, instructorsIds)).pipe(
        mergeMap(response => {
          response.conversations.map(convo => {
            let properties = convo;
            if (convo.previewMessageData.content === '') {
              properties['previewMessageData'].content =
                'ファイルを受信しました。';
            }
            return properties;
          });

          const conversations = arrayOfObjectsToObject(
            response.conversations,
            'id',
          );

          return [
            getConversationsWithInstructorsSuccess({
              conversations,
              adminConvo: response.adminConvo,
            }),
          ];
        }),
        catchError(error => {
          return of(getConversationsWithInstructorsFailure(error));
        }),
      );
    }),
  );

export default combineEpics(
  createOrUpdateConversationEpic,
  getConversationsEpic,
  getMessagesEpic,
  getConversationByIdEpic,
  updateConvoReadStatusEpic,
  getFileBlobEpic,
  getConversationsWithInstructorsEpic,
  fetchMessagesEpic,
);
